export default __webpack_public_path__ + "static/media/sunny-agency.5cbdf3f4.webp";